<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="linenumberForm">
        <div class="">
          <h3 class="form_name">Line Number</h3>
  
  
          <div class="input">
            <label for="">Line Number</label>
            <input type="text" class="default_input reference-form" formControlName="LineNumber" />
          </div>

          <div class="input">
            <label for="">Line Number Name</label>
            <input type="text" class="default_input reference-form" formControlName="LineNumberName" />
          </div>

          <!-- <div class="input">
            <label for="">Subscriber Email</label>
            <input type="text" class="default_input reference-form" formControlName="SubscriberEmail" />
          </div> -->
  
  
          <div class="btn_holder">
            <button class="default_primary-button" *ngIf="selectedIndex === null"
              (click)="addNew(linenumberForm.value)">Add</button>
            <button class="default_primary-button" *ngIf="selectedIndex !== null"
              (click)="addNew(linenumberForm.value)">Update</button>
            <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
          </div>
  
        </div>
      </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search" placeholder="Search for LineNumber" [formControl]="control"
            [appAutocomplete]="autocomplete" />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container *ngIf="(linenumbers | filterReference: control.value) as result">
                <app-option (click)="selectLineNumber(option.id)" *ngFor="let option of result" [value]="option.LineNumberName">
                  {{ option.LineNumberName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head">
          <span class="item">S/N</span>
          <span class="item">Line Number</span>
          <span class="item">Line Number Name</span>
          <!-- <span class="item">Subscriber Email</span> -->
          <span class="item">Action</span>
  
        </div>
  
        <div class="scroll">
  
        </div>
        <div class="body_content">
          <div class="the_body" *ngFor="let linenumber of linenumberFormArray.get('LineNumbers')['controls']; index as i"
            (click)="onEdit(i, linenumber.value)" style="cursor: pointer;" matTooltip="Click to edit"
            aria-label="Button that displays a tooltip when focused or hovered over">
            <span class="content">{{i + 1}}</span>
            <span class="content">{{linenumber.value.LineNumber}}</span>
            <span class="content">{{linenumber.value.LineNumberName}}</span>
            <!-- <span class="content">{{linenumber.value.SubscriberEmail}}</span> -->
            <span class="content" (click)="$event.stopImmediatePropagation()">
              <button class="delete_icon trash" (click)="deleteLineNumber(i, linenumber.value)">
                <em class="ti-trash"> </em> </button>
            </span>
  
          </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(linenumberFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  